/**
 * 旧 JS（public_html/js・public_html/assets/js/legacy）が参照するグローバル変数の暫定ブリッジ
 * MEMO: 旧 js/common.js（frontend/legacy-ref/common.js）がトップレベルで定義していた変数を、同じ名前・同じ値で window に出す
 *       旧 order-common.js などは ua・root・host・host_*・set_url_* を前提にしているため、common の ESM 化で消えて動かなくなっていた
 *       すべての旧 JS の ESM 化が終わったら、このファイルごと削除する
 */
import { getAppEnv } from '@/utils/env'

//旧 common.js の各環境のホスト
const LEGACY_HOSTS = {
    host_local: 'localhost:8180',
    host_dev: 'dev.lion-meishi.com',
    host_cloud: 'xserver.lion-meishi.com',
    host_dev_cloud: 'dev-xserver.lion-meishi.com',
    host_nxg: 'ore-no-nxg.lion-meishi.com',
    host_nxg_mobile: 'nxg.lion-meishi.com',
    host_product: 'www.lion-meishi.com',
    host_prd: 'www.lion-meishi.com',
    host_prd_2: 'lion-meishi.com',
    host_jichi: 'jichitai.lion-meishi.com',
    host_jichi_dev: 'dev-jichitai.lion-meishi.com',
}

/**
 * 旧 common.js と同じグローバル変数を window に設定する
 *   root は ESM 版の getAppEnv() に合わせる（旧 getItemPriceApi.js などの root による分岐も、同じ結果になる）
 */
export const setLegacyGlobals = (): void => {
    const env = getAppEnv()
    const { http } = env
    const globals: Record<string, unknown> = {
        my_func_number_format_php: (num: number | string): string => String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'),
        device: env.device,
        ua: env.ua,
        event: env.event,
        protocol: env.protocol,
        http,
        host: env.host,
        ...LEGACY_HOSTS,
        set_url_local: http + LEGACY_HOSTS.host_local,
        set_url_dev: http + LEGACY_HOSTS.host_dev,
        set_url_nxg: http + LEGACY_HOSTS.host_nxg,
        set_url_nxg_mobile: http + LEGACY_HOSTS.host_nxg_mobile,
        set_url_product: http + LEGACY_HOSTS.host_product,
        set_url_prd: http + LEGACY_HOSTS.host_prd,
        set_url_prd_2: http + LEGACY_HOSTS.host_prd,
        set_url_jichi: http + LEGACY_HOSTS.host_jichi,
        set_url_jichi_dev: http + LEGACY_HOSTS.host_jichi_dev,
        root: env.root,
        device_lower: env.device.toLowerCase(),
        browser: env.browser,
    }
    Object.assign(window, globals)
}
